const globalStyle = {
    setColor: (color) => ({
        color: color
    }),
    setBackgroundColor: (backgroundColor) => ({
        backgroundColor: backgroundColor
    })
}

export default globalStyle;